import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { ArticleView } from "../components/ArticleView";
import { Seo } from "../components/Seo";
import { getArticleBySlug } from "../content";
import { buildArticleHead } from "../seo";
import { NotFoundPage } from "./NotFoundPage";

/**
 * The routed wrapper. It resolves the slug and does nothing else, so that
 * `ArticleView` stays free of router hooks and can be rendered to static HTML
 * by the build script.
 */
export function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = slug ? getArticleBySlug(slug) : undefined;
  const head = useMemo(
    () => (article ? buildArticleHead(article) : null),
    [article],
  );

  if (!article || !head) return <NotFoundPage />;

  return (
    <>
      <Seo head={head} />
      <ArticleView article={article} />
    </>
  );
}
